<!-- 有时间需重写 目前 四层父子关系十分复杂  （目前可勉强使用）-->
<!-- 因 摄像头组件 只有一个组件可显像 所以 需要来回传值十分嘈杂哦 后面需要整合 人脸抓拍组件  -->
<template>
	<div class="uni-startPractice onlineExamOwn" ref="screenshot" v-loading="isLoading" element-loading-text="加载中，请稍等...">
		<!-- <div class="onlineTestBack"></div> -->
		<PromptBox ref="promptBox" @setSubmit="setSubmit" @clearData="clearData" @getRadioSelect="getRadioSelect" @destroy="destroy" />
		<div class="leftBox" id="leftBox">
			<!-- 标题 -->
			<div class="title-box">
				<div class="title">
					<i class="iconfont iconfanhui" @click="$router.go(-1)"></i>
					<span v-for="(item, index) in otherInfoDTO.title" :key="index">
						{{ item }} - {{dataText.exam_plan.course_title}}
						<em v-if="otherInfoDTO.title.length - 1 !== index"></em>
					</span>
				</div>
				<div class="info-box">
					<span class="text">姓名： {{ studentInfo.student_title }}</span>
					<span class="text">学号： {{ studentInfo.student_code }}</span>
					<span class="text">班级： {{ studentInfo.class_title }}</span>
				</div>
			</div>

			<!-- :class="fontClass" -->
			<div
				class="topicDivButton"
				v-for="(itemTo, indexTo) in topicLists"
				:key="indexTo"
			>
				<div
				class="topicDiv"
				:id="itemTo.question_style != 6 && `id_${itemTo.sort}`"
				>
					<!-- 1 单选题 -->
					<ChoiceOne
						v-if="itemTo.question_style === 1"
						:datas="itemTo"
						@next="saveAnswer(itemTo)"
					/>
					<!-- 2 判断题 -->
					<Judge
						v-if="itemTo.question_style === 2"
						:datas="itemTo"
						@next="saveAnswer(itemTo)"
					/>
					<!-- 3 多选题 -->
					<ChoiceMultiple
						v-if="itemTo.question_style === 3"
						:datas="itemTo"
						@next="saveAnswer(itemTo)"
					/>
					<!-- 4 填空题 -->
					<FillBlank
						v-if="itemTo.question_style === 4"
						:datas="itemTo"
						@next="saveAnswer(itemTo)"
					/>
					<!-- 5简答题 -->
					<Subjective
						v-if="itemTo.question_style === 5"
						:datas="itemTo"
						@next="saveAnswer(itemTo)"
					/>
					<!-- 6 一题多问 -->
					<div v-if="itemTo.question_style === 6">
						<div
						class="questionAskTitle"
						id="questionAskTitle"
						v-html="itemTo.content"
						></div>
						<!-- 音频 -->
						<div class="audioDiv" v-if="itemTo.audio_url">
						<audio
							class="sourceAudio"
							controls="controls"
							v-for="(itemAudio, indexAudio) in itemTo.audio_url.split(',')"
							:key="indexAudio"
						>
							<source :src="itemAudio" type="audio/ogg" />
							Your browser does not support the audio element.
						</audio>
						</div>
						<!-- 小题 -->
						<div
						v-for="(item, index) in itemTo.child"
						:key="index"
						:id="`id_${item.sort}`"
						>
						<!--      1 单选题-->
						<ChoiceOne
							v-if="item.question_style === 1"
							:datas="item"
							@next="saveAnswer(item)"
						/>
						<!--     4 填空题-->
						<FillBlank
							v-if="item.question_style === 4"
							:datas="item"
							@next="saveAnswer(item)"
						/>
						<!--      2判断题-->
						<Judge
							v-if="item.question_style === 2"
							:datas="item"
							@next="saveAnswer(item)"
						/>
						<!--      3多选题-->
						<ChoiceMultiple
							v-if="item.question_style === 3"
							:datas="item"
							@next="saveAnswer(item)"
						/>
						<!-- 5简答题 -->
						<Subjective
							v-if="item.question_style === 5"
							:datas="item"
							@next="saveAnswer(item)"
						/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 工具栏 -->
		<div class="mat20" style="min-height: inherit">
		<Sheet
			ref="sheet"
			:datas="topicCard"
			:dataText="dataText"
			:total="total"
			:timeDate="timeDate"
			:isFaceVideo="!isFaceVideo"
			:showTime="true"
			@change="jumpTo"
			@submit="submit"
			@forcedSubmit="forcedSubmit"
			@showCountDownTips="showCountDownTips"
		/>
		</div>
		<Face @FaceType="FaceType" ref="face" v-if="isFaceVideo" :make_id="dataText.info.id" :isTest="isFaceVideo" @isRouter="isRouter" @forcedSubmit="forcedSubmit" />
	</div>
</template>
<script>
import PromptBox from './module/promptBox.vue';
import { getStore, removeStore, setStore } from '@/utils/localStorage';
// import ComponentDialog1 from '@/components/componentDialog1';
import Face from './../participateTestOwn/module/face';

import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";

import Sheet from './module/sheet';
import { startExam, postAnswer, topicSubmit, faceServe, examUpScreenshot } from '@/api/exam';

import { jsToFormData } from '@/utils/func';
import screenfull from 'screenfull';

import html2canvas from 'html2canvas';
import { putObject } from "@/utils/upload";
import base64ImgtoFile from '@/utils/base64ImgtoFile';

export default {
	name: 'onlineExamOwn',
	components: { 
		PromptBox, 
		Face, 
		Sheet,
		ChoiceOne, //单选
		FillBlank, //填空
		Judge, //判断
		ChoiceMultiple, //多选
		Subjective, //简答题
	},
	data() {
		return {
			otherInfoDTO: "",
			topicLists: [],
			topicCard: [],
			total: 0,
			timeDate: '',  //结束时间
			
			// make_record_id: this.$route.query.make_record_id,
			make_record_id: '', 
			is_exam: this.$route.query.is_exam,
			test_id: this.$route.query.test_id,
			exam_id: this.$route.query.id,
			typeTest: this.$route.query.typeTest,
			showEwm: '',
			make_id: this.$route.query.make_id,
			formData: [
				{
					dataAuth: ''
				}
			],
			// setFaceData: '',
			isTime: '',
			titleName: '',
			// answerSheetGroupDTOS: [],
			dataText: {},
			indexNumTop: 0,
			// dataTextLength: 0,
			topicList: [],
			answer: [],
			// typeTitle: ['填空题样式', '判断题样式', '多选题样式', '单选题样式'],
			isFaceVideo: false,
			isLoading: false,
			isFaceNumber: 0, // 当前调用第几次人脸识别功能
			illegalOperation: 0,
			// isScoreVisible: false,
			scoreNum: 0,
			fontSizeText: '15px',
			setOutTime: '',
			letterIndex: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
			// timeFd: '',
			score: '',
			examDestroy: true,
			acltCount: 0,
			face_maxs: 0,
			face_Time: '',
			//学生信息
			studentInfo: {
				student_title: '',
				student_code: '',
				class_title: ''
			},  
			isScreenshot: true,  //是否截图
			screenshotNum: 2,  //最大截图数量
			currScreenshotNum: 0,  //当前截图数量
			screenshotInterval: null,  //截图定时器
			screenshotIntervalDate: 10000,  //截图间隔时间
		};
	},

	mounted() {
		this.getData(); //获取数据
		this.listenFullScreen(); //监听是否开启全屏
		// this.listeningLeave(); //监听是否离开窗口15秒
	},
	created() {
		this.$nextTick(() => {
			// 禁止右键
			document.oncontextmenu = new Function('event.returnValue=false');
			// 禁用选择
			document.onselectstart = new Function('event.returnValue=false');
			document.onkeydown = document.onkeyup = document.onkeypress = function(event) {
				var e = event || window.event || arguments.callee.caller.arguments[0];
				// 禁止F12和F5 Ctrl+R shift+F10
				// if (e && (e.keyCode == 123 || (e.keyCode == 116 && e.type != 'keypress') || (event.ctrlKey && event.keyCode == 82) || (event.shiftKey && event.keyCode == 121))) {
				if (e && e.keyCode == 123) {
					e.returnValue = false;
					return false;
				}
			};
			screenfull.toggle();
			this.screenshotHandle();
		});
	},
	destroyed() {
			this.examDestroy = false;
			clearInterval(this.setOutTime);
			clearInterval(this.face_Time);
			clearTimeout(this.setOutTime);
			clearInterval(this.screenshotInterval);
			let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
			if(isFullScreen){
				screenfull.toggle();
			}
	},
	methods: {
		// 截图
		screenshotHandle(){
			if(this.isScreenshot){
				this.screenshotInterval = setInterval(() => {
					html2canvas(this.$refs['screenshot']).then(canvas => {
						const imageURL = canvas.toDataURL('image/png');
						const date = new Date();
						const dateNum = date.getTime(); 
						const fileName = '考试截图' + dateNum;
						const file = base64ImgtoFile(imageURL, fileName);
						// 上传图片
						putObject(file, (url) => {
							const data = {
								sign_id: this.otherInfoDTO.sign_student_id,
								url,
							};
							examUpScreenshot(data).then(res => {
								this.currScreenshotNum += 1;
								if(this.currScreenshotNum >= this.screenshotNum){
									clearInterval(this.screenshotInterval);
								}
							});
						}, null, 'file', '', false, 0.1, false)
					});
				}, this.screenshotIntervalDate);
			}
		},
		// 倒计时提示
		showCountDownTips(){
			this.$refs.promptBox.isOpen('countDown');
		},
		upCaptures() {
			// console.log('抓拍newupCaptures');
			this.$refs.face.upCapture();
		},
		//销毁
		destroy() {
			document.onkeydown = document.onkeyup = document.onkeypress = null;
			document.addEventListener('visibilitychange', () =>null);
			this.closeQr();
		},
		// 监听是否开启全屏
		listenFullScreen() {
			['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
				window.addEventListener(item, () => this.fullscreenchange());
			});

			// document.addEventListener('fullscreenchange', () => {
			// console.log(this.examDestroy);
			// 	if (!document.fullscreenElement && this.examDestroy == true) {

			// 	}
			// });
		},
		fullscreenchange() {
			let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
			if (isFullScreen) {
				//  进入全屏
			} else if(this.examDestroy) {
				// screenfull.toggle();
				// this.$refs.promptBox.isOpen('isFullScreen');
			}
		},
		// 监听是否离开当前窗口15s
		// listeningLeave() {
		// 	const than = this;
		// 	document.addEventListener('visibilitychange', () => {
		// 		if (document.visibilityState === 'hidden' && this.examDestroy) {
		// 			than.autoSubmitFocus();
		// 			than.$refs.promptBox.isOpen('leave');
		// 			this.acltCount++;
		// 		} else {
		// 			than.autoSubmitFocus(2);
		// 		}
		// 	});
		// },
		//检测是否移出屏幕
		// showEwms(i){
		//   this.showEwm=i;
		// },
		// 修改字体大小
		setFontSize(size) {
			this.fontSizeText = size;
		},
		// 是否显示弹框
		// isShowComponentDialog() {
		// 	this.isScoreVisible = true;
		// },
		isRouter() {
			this.isFaceVideo = false;
			setStore('isFaceVideo', this.isFaceVideo);
			this.face_maxs++;
			// console.log('重启exam');
			this.$refs.sheet.openCameraface();
		},
		// 查看解析
		confirm() {
			this.$router.replace({
				name: 'practiceAnalysis',
				query: {
					make_id: this.dataText.info.id
				}
			});
		},
		// 再考一次
		cancel() {
			this.clearData();
			this.$router.go(-1);
		},
		// 强制提交
		async forcedSubmit() {
			const dataC = {
				make_id: this.make_record_id,
				force: 1
			};
			const params = jsToFormData(dataC);
			const data = await topicSubmit(params);
			if (data.code === 200) {
				this.destroy();
				this.$router.replace('/onlineExamSuccessOwn');
			}
			// this.clearData();
		},
		// 监听是否在当前浏览器
		// autoSubmitFocus(type) {
		// 	if (type === 2) {
		// 		clearTimeout(this.setOutTime);
		// 		return;
		// 	}
		// 	if (this.acltCount >= 1) {
		// 		clearTimeout(this.setOutTime);
		// 		this.forcedSubmit()
		// 	}
		// 	this.setOutTime = setTimeout(() => {
		// 		this.forcedSubmit();
		// 	}, 1000 * 15);
		// },
		// 监听是否离开当前浏览器
		// autoSubmit() {
		// 	if (this.$route.path !== '/onlineTest') return;
		// 	this.illegalOperation++;
		// 	setStore('cuntNumber', this.illegalOperation);
		// 	if (this.illegalOperation === 2 || getStore('cuntNumber') === '2') {
		// 		this.forcedSubmit();
		// 		return;
		// 	}
		// 	this.$refs.promptBox.isOpen('leave');
		// },
		// 保存数据
		storeData() {
			setStore('formData', this.formData);
		},
		// 清除数据
		clearData() {
			removeStore('formData');
			removeStore('cuntNumber');
			removeStore('isFullScreen');
			removeStore('isFaceNumber');
			removeStore('isFaceVideo');
		},

		// 获取题目内容
		async getData() {
			let res = await startExam({ id: this.exam_id });
			if (res.code == 200) {
				this.dataText = res.result;
				const { info, question, questionTitleList, sum, remaining_time } = res.result;
				this.otherInfoDTO = info;
				this.otherInfoDTO.title = info.title ? info.title.split("|") : [];
				this.topicLists = question;
				this.topicCard = questionTitleList;
				this.total = sum;
				this.timeDate = remaining_time;
				this.make_record_id = res.result.info.id;
				const {student_title,student_code,class_title} = info;
				this.studentInfo = {student_title,student_code,class_title};
			}

			// this.changeData();
			// this.everyTimeFace();
			this.isLoading = false;
			this.FaceRecognition();
		},
		//人脸识别
		FaceRecognition() {
			let { face_rate, face_max } = this.dataText.exam_plan;
			if (face_rate != 0 && face_max != 0) {
				this.face_Time = setInterval(() => {
					this.FaceIdentify(face_max);
				}, face_rate * 60000);
			}
		},
		FaceIdentify(max) {
			if (this.face_maxs >= max) {
				clearTimeout(this.face_Time);
			} else {
				this.isFaceVideo = true;
			}
		},
		FaceType() {
			this.isFaceVideo = false;
		},
		// 下一题
		saveAnswer(item) {
			this.getRadioSelect(item);
		},
		// 点击答题卡，跳转道对应的题
		jumpTo(sort) {
			let scrollDom = document.getElementById("leftBox");
			let dom = document.querySelector("#id_" + sort);
			if (!dom) {
				return;
			}
			let top = dom.offsetTop - 200;
			scrollDom.scrollTo({
				top: top,
				behavior: "smooth",
			});
		},
		// '填空题','判断题','多选题','单选题'
		getRadioSelect(item) {
			// let option = item.choice_correct_item;
			// const params = {
			//   id: item.id,
			//   make_id: item.make_id,
			//   option: option,
			// };
			const params = {
				id: item.id,
				make_id: item.make_id,
				option: (() => {
					if(item.question_style == 4){
						// 填空
						if(item.choice_correct_item){
							let choice_correct_item = JSON.parse(item.choice_correct_item);
							let isValue = choice_correct_item.some(item => item.value !== '');
							if(!isValue){
								return '';
							}else{
								return item.choice_correct_item;
							}
						}else{
							return '';
						}
					}else{
						return item.choice_correct_item || "";
					}
				})(),
			};
			// if(item.choice_correct_item != '' && item.choice_correct_item != 'null' && item.choice_correct_item != null){
			//   params.option = item.choice_correct_item
			// }
			if(item.choice_correct_thumb != '' && item.choice_correct_thumb != 'null' && item.choice_correct_thumb != null){
				params.choice_correct_thumb = item.choice_correct_thumb.toString();
			}
			const data = jsToFormData(params);
			postAnswer(data).then(() => {
				this.storeData();
			});

			this.changeStatus(item);

			// 单选题、判断题滚动到下一题
			if (item.question_style == 1 || item.question_style == 2) {
				this.jumpTo(item.sort + 1);
			}
		},
		// 改变当前答题卡状态
		changeStatus(item) {
			let isNoEmpty = false;
			if (!item.choice_correct_item || item.choice_correct_item != "[]") {
				isNoEmpty = true;
			}
			if (item.question_style == 4) {
				let isValue = false;
				if(item.choice_correct_item){
					isValue = JSON.parse(item.choice_correct_item).some((val) => val.value != "")
				}
				if(isValue || item.choice_correct_thumb){
					isNoEmpty = true;
				}else{
					isNoEmpty = false;
				}
			}
			if (item.question_style == 5 ) {
				if(item.choice_correct_item !== '' || item.choice_correct_thumb){
					isNoEmpty = true;
				}else{
					isNoEmpty = false;
				}
			}
			this.topicCard.forEach((item2) => {
				item2.list.forEach((val) => {
				if (val.sort == item.sort) {
					val.is_make = isNoEmpty ? 1 : 0;
				}
				});
			});
		},
		// 上传二维码
		openQrCode(indexNumTop) {
			this.indexNumTop = indexNumTop;
			this.$refs.qrCode.isShowOpen();
		},
		// 返回弹框
		openReturn() {
			this.$refs.promptBox.isOpen('return');
		},
		closeQr() {
			if (this.isTime) {
				clearInterval(this.isTime);
				this.isTime = null;
			}
		},
		// 删除图片
		setDelete() {
			this.formData[this.indexNumTop].imgData = '';
		},
		//接收工具栏内容
		isOpenPromptBox() {
			this.$refs.promptBox.isOpen('submit');
		},
		// 点击提交
		submit(){
			this.$refs.promptBox.isOpen('submit');
		},
		// 提交试卷
		async setSubmit() {
			const dataC = {
				make_id: this.make_record_id,
				force: 0
			};
			const params = jsToFormData(dataC);
			const data = await topicSubmit(params);
			if (data.code === 200) {
				// if (this.typeTest != 1) {
				// 	this.scoreNum = data.result.info.score;
				// 	this.isScoreVisible = true;
				// 	return;
				// }
				this.destroy();
				this.$router.replace('/onlineExamSuccessOwn');
			}
		}
	}
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.onlineExamOwn{
	.title-box{
		position: relative;
		.info-box{
			position: absolute;
			top: 10px;
			right: 10px;
			.text{
				display: block;
			}
		}
	}
}
.onlineTestBack {
	width: 100%;
	height: 100%;
	position: fixed;
	background-color: #e8e8e8;
}
.topicDivButton {
  background: #fff;
  margin-bottom: 20px;
}
.topicDiv {
  padding-bottom: 30px;
}
.uni-startPractice {
  display: flex;
  min-height: $contentH;
  .iconfanhui {
    color: #999999;
    font-size: 38px;
    position: absolute;
    left: 20px;
    &:hover {
      color: #666666;
    }
  }
  .spanColor {
    color: #666666;
    font-size: 14px;
  }
  .leftBox {
    //background-color: #ffffff;
    // height: $contentH;
    height: 100vh;
    flex: 1;
    //padding: 20px 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 20px 20px 0 20px;
    position: relative;
    &::-webkit-scrollbar {
      @include uni-hidden;
    }
    .titlePosition {
      width: calc(100% - 624px);
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      background: #fff;
      height: 80px;
      position: fixed;
      top: $headH;
      z-index: 10;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      span {
        font-size: 20px;
        color: #333;
        font-weight: 400;
        display: flex;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
        em {
          margin: 0 14px;
          display: flex;
          height: 26px;
          width: 1px;
          background: $gray;
        }
      }
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      height: 80px;
      position: relative;
      transition: all 0.3s ease;
      span {
        font-size: 20px;
        color: #333;
        font-weight: 400;
        display: flex;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
        em {
          margin: 0 14px;
          display: flex;
          height: 26px;
          width: 1px;
          background: $gray;
        }
      }
    }

    .total-text {
      display: flex;
      color: $grayLight;
      margin-top: 20px;
      padding: 10px 0;
      border-bottom: 1px solid $grayLight2;
      flex-wrap: wrap;
      .totalTextSpan {
        margin-bottom: 5px;
      }
    }

    .clear {
      margin: 65px 60px 0 60px;
      height: 1px;
      border: 1px dashed #e8e8e8;
    }
    .speed {
      padding-bottom: 52px;
      border-bottom: 1px dashed #e8e8e8;
      .text {
        color: #9a9a9a;
        font-size: 14px;
        margin: 30px 0 20px 0;
      }
      .strip {
        display: flex;
        align-items: center;
        .box {
          flex: 1;
        }
        .textBox {
          margin-left: 32px;
          span {
            font-size: 14px;
            color: #9a9a9a;
            &:first-child {
              color: #f38829;
            }
          }
          em {
            font-style: normal;
            margin: 0 10px;
            color: #9a9a9a;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
.questionAskTitle {
  width: 100%;
  padding: 20px;
  background-color: #f8f8f8;
  text-indent: 2em;
  line-height: 26px;
  color: #333;
  word-break: break-word;
  white-space: pre-line;
}
.audioDiv {
  display: inline-block;
}
.audioDiv .sourceAudio {
  width: 300px;
  margin: 20px;
}
</style>
